@if (loader.message) {
  <div class="loader-class">
    <mat-spinner color="primary"></mat-spinner>
    <div class="loader-message">{{loader.message}}</div>
  </div>
}
@if (errorMessage) {
  <div class="error-container">
    <div class="div-error-icon"><mat-icon>error_outline</mat-icon></div>
    <div class="loader-message">{{errorMessage}}</div>
  </div>
}
@if (!loader.isLoading && !errorMessage) {
  <div class="configuration-container">
    <div class="table-container">
      <app-table-template [tableData]="tableData" [columnList]="columnList" [showDeleteButton]="true"
        [multiSortMeta]="multiSortMeta" sortMode="multiple" [loading]="false"
        [validateFn]="validateItem.bind(this)" [canExitEditOnSaveFn]="handleAddUpdateAdmin.bind(this)"
        (actionButtonClicked)="handleButtonClicked($event)" (editInputChanged)="onEditInputChanged($event)"
        [editableTable]="canModifyAdmin" (pageDetails)="rewriteRouteQueryParams($event.page, $event.rows)"
        [page]="page" [rowsPerPage]="rowsPerPage" [rowsPerPageOptions]="rowsPerPageOptions">
        <div class="header-container">
          @if (canModifyAdmin) {
            <button class="action-button add-user" mat-raised-button color="primary" 
              [disabled]="tableComponent?.isEditMode || loader.message !== ''" (click)="addNewAdminItem()">
              Add New User
            </button>
          }
          <div class="admin-config-title">
            {{title}}
          </div>
        </div>
      </app-table-template>
    </div>
    @if (isBulkSave && canModifyAdmin) {
      <div class="div-footer">
        <p-button label="Cancel" [raised]="true" severity="secondary" (onClick)="onCancel()" />
        <p-button label="Update" [raised]="true" (onClick)="onSubmit()" />
      </div>
    }
  </div>
}
<ng-template #autoCompleteUserTemplate let-entry="entry">
  <app-user-autocomplete [entry]="entry" [fieldToSave]="'email_id'"></app-user-autocomplete>
</ng-template>